import { FormTable, FormTableHeader } from 'stories/components'

type ConstructionTrackRecordsProps = {
  requiredTracks: number
  trackStatusOk: boolean
  canEdit: boolean
  inputs: Record<string, any>
  defaultData: any[]
  onSubmitTrack: (id: any, values: Record<string, any>, key: string) => Record<string, any>
  onRemoveTrack: (id: any, key: string) => void
  showHistory: (key: string, headers?: Array<FormTableHeader>) => void
}

export function ConstructionTrackRecords({
  requiredTracks,
  trackStatusOk,
  canEdit,
  inputs,
  defaultData,
  onSubmitTrack,
  onRemoveTrack,
  showHistory,
}: ConstructionTrackRecordsProps) {
  return (
    <div>
      <FormTable
        key="track"
        header={[
          { key: 'address', title: 'Address' },
          { key: 'owner', title: 'Owner on Title' },
          { key: 'constructionStartDate', title: 'Start Date' },
          { key: 'constructionCompDate', title: 'Completion Date' },
          { key: 'newConstruction', title: 'Ground Up?' },
          { key: 'budget', title: 'Budget' },
          { key: 'projectTypes', title: 'Project Types' },
          { key: 'units', title: 'Total Units' },
          { key: 'revenue', title: 'Total Revenue' },
        ]}
        permission={canEdit ? 1 : 3}
        inputs={inputs}
        defaultData={defaultData}
        onSubmit={(id, values) => onSubmitTrack(id, values, 'track')}
        onRemove={(id) => onRemoveTrack(id, 'track')}
        showHistory={(headers) => showHistory('track', headers)}
      />
      {!trackStatusOk && (
        <div
          className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative text-[16px] my-4"
          role="alert"
        >
          At least {requiredTracks} track records are required!
        </div>
      )}
    </div>
  )
}
